import React from 'react'
import { GridSemaforoPure } from '../../pures'
import { Grid } from '@material-ui/core'
import { ButtonHLPure } from '../../pures'

const RepseStatusByCompanyContractorsView = (props) => {
    return (
        <>
            <div className=''>
                <GridSemaforoPure
                    columnTitle={"Proveedor"}
                    dataItems={props.contractors}
                    buttonTitle={"Ver detalle"}
                    onButtonClick={(company) => props.onContractorSelected(company)}
                    getColorByStatus={(status) => props.getColorByStatus(status)}
                    yearShown={props.yearShown}
                />
                <Grid
                    container
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    className="repseStatusByCompany-actionsContainer"
                >
                    <div className='justify-right'>
                        <ButtonHLPure
                            nameBtn="Regresar"
                            onClickBtn={props.onBack}
                        />
                    </div>
                </Grid>
            </div>
        </>
    )
}

export default RepseStatusByCompanyContractorsView